import type { ReactNode } from "react"

export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  center = true,
}: {
  eyebrow?: string
  title: ReactNode
  subtitle?: string
  center?: boolean
}) {
  return (
    <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div className="inline-flex items-center rounded-full border border-glow px-3 py-1 text-xs font-medium text-primary mb-4">
          {eyebrow}
        </div>
      )}
      <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight">{title}</h2>
      {subtitle && (
        <p className="mt-4 text-lg text-muted-foreground leading-relaxed">{subtitle}</p>
      )}
    </div>
  )
}
